// extracted by mini-css-extract-plugin
export default {"container":"ChangeLanguage__container__OWIiL"};